// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__fedraLight_f227bc', '__fedraLight_Fallback_f227bc', s, a, n, s, -, s, e, r, i, f","fontStyle":"normal"},"className":"__className_f227bc"};